module.exports = __webpack_public_path__ + "resources/img/sp_pricing.3b97cf6e95eeb13dd77b02131d2a2373.png";